import axios from '@/util/axios';

export default {
  namespaced: true,
  state() {
    return {
      notifications: [],
      supportRequests: [],
      latestReplies: [],
    };
  },
  mutations: {
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setLatestPendingTickets(state, payload) {
      state.supportRequests = payload;
    },
    setLatestReplies(state, payload) {
      state.latestReplies = payload;
    },
  },
  actions: {
    getNotifications({ commit }) {
      axios.get('/unread-notifications').then(({ data }) => {
        commit('setNotifications', data.data);
      });
    },
    loadLatestPendingTickets({ commit }) {
      axios.get('/latest-pending-tickets').then((response) => {
        commit('setLatestPendingTickets', response.data.data);
      });
    },
    loadLatestReplies({ commit }) {
      axios.get('/latest-replies-from-customers').then((response) => {
        commit('setLatestReplies', response.data.data);
      });
    },
  },
  getters: {
    notificationList: (state) => state.notifications,
    supportRequests: (state) => state.supportRequests,
    latestReplies: (state) => state.latestReplies,
  },
};
